import app from "/src/app/app.module";
import moment from "moment";

app.controller('contactFormsCtrl', function ($scope, $contactForms, $filter, tabService,
                                             msgBus, selectionFilters, vxUtils, $locale, msgBusActions) {
    var tab = tabService.getCurrentTab();
    $scope.tab = tab;
    $scope.suspended = false;

    // Filter for processed status
    var statusFilters = [
        {
            type: 'status',
            items: [
                {label: vxUtils.loc('ALL'), value: 'all', selected: true},
                {label: vxUtils.loc('UNPROCESSED'), value: 'unprocessed', selected: false},
                {label: vxUtils.loc('PROCESSED'), value: 'processed', selected: false}
            ]
        }
    ];

    // Default to last 30 days
    var initialDate = {startDate: moment().add(-29, 'days'), endDate:  moment().add(1, 'days')};

    $scope.overviewCpi = {
        openItemPage: "/src/pages/contact-forms/contact-form-details.html",
        openItemIcon: "fa fa-envelope",
        type: 'contact-form',
        tabItems: $scope.openItems,
        filters: statusFilters,
        date: initialDate,
        searchChanged: function (text) {
            $scope.overviewCpi.items = $filter('filter')($scope.overviewCpi.all, {$: text});
            $scope.overviewCpi.reload();
        },
        dateChanged: function (newDate) {
            $scope.lastdate = newDate;
            $scope.getItems(newDate);
        },
        selectionChanged: function (data) {
            var selectedStatus = null;
            angular.forEach($scope.overviewCpi.filters, function (filterGroup) {
                if (filterGroup.type === 'status') {
                    angular.forEach(filterGroup.items, function (item) {
                        if (item.selected && item.value !== 'all') {
                            selectedStatus = item.value;
                        }
                    });
                }
            });

            if (selectedStatus === 'processed') {
                $scope.overviewCpi.items = $filter('filter')($scope.overviewCpi.all, {isProcessed: true});
            } else if (selectedStatus === 'unprocessed') {
                $scope.overviewCpi.items = $filter('filter')($scope.overviewCpi.all, {isProcessed: false});
            } else {
                $scope.overviewCpi.items = $scope.overviewCpi.all;
            }
            $scope.overviewCpi.reload();
        }
    };

    $scope.columns = [
        {title: '#', field: 'id', visible: true, sortable: 'id'},
        {
            title: vxUtils.loc('STATUS'),
            field: 'statusIcon',
            visible: true,
            icon: true,
            hastooltip: true,
            hover: function (item, column) {
                column.tooltipobj = item.isProcessed ? vxUtils.loc('PROCESSED') : vxUtils.loc('UNPROCESSED');
                column.tooltipopen = true;
            }
        },
        {
            title: vxUtils.loc('DATE'),
            field: 'createdAt',
            visible: true,
            filter: "date",
            args: $locale.DATETIME_FORMATS.short,
            sortable: 'createdAt',
            initalSort: 'desc'
        },
        {title: vxUtils.loc('NAME'), field: 'name', visible: true, sortable: 'name'},
        {title: vxUtils.loc('QUOTE_TYPE'), field: 'quoteType', visible: true, sortable: 'quoteType'},
        {title: vxUtils.loc('EVENT_TYPE'), field: 'eventType', visible: true, sortable: 'eventType'},
        {title: vxUtils.loc('EVENT_DATE'), field: 'eventDate', visible: true, sortable: 'eventDate'},
        {title: vxUtils.loc('EVENT_LOCATION'), field: 'eventLocation', visible: true},
        {title: vxUtils.loc('EXPECTED_GUESTS'), field: 'expectedGuests', visible: true, sortable: 'expectedGuests'},
        {title: vxUtils.loc('EMAIL'), field: 'email', visible: true},
        {title: vxUtils.loc('TELEPHONE'), field: 'phone', visible: true},
        {
            title: vxUtils.loc('MESSAGE'),
            field: 'message',
            visible: true,
            hastooltip: false,
            style: {'max-width': '200px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}
        },
        {title: vxUtils.loc('REFERRAL_SOURCE'), field: 'referralSource', visible: true},
        {title: vxUtils.loc('FORM_NAME'), field: 'formName', visible: true}
    ];

    $scope.getItems = function (date) {
        // If no date provided (initial load or manual refresh), use current date range
        var range = date || $scope.overviewCpi.date || initialDate;
        // dateChanged from filterbar already provides unix timestamps, but initial load uses moment objects
        var start = typeof range.startDate === 'number' ? range.startDate : Math.floor(range.startDate.unix());
        var end = typeof range.endDate === 'number' ? range.endDate : Math.floor(range.endDate.unix());
        $contactForms.getAll(function (results) {
            $scope.overviewCpi.all = results;
            $scope.overviewCpi.selectionChanged(null);
        }, null, start, end);
    };

    msgBus.onMsg(msgBusActions.overviewReload, function (sender, mssg) {
        if (mssg === 'contact-form')
            $scope.getItems($scope.lastdate);
    }, $scope);

    // Initial load with default date range
    $scope.getItems(initialDate);
});
